const useTagsViewStore = defineStore(
  'tags-view',
  {
    state: () => ({
      visitedViews: [],
      cachedViews: [],
      iframeViews: []
    }),
    actions: {
      normalizeView(view) {
        return {
          ...view,
          meta: { ...(view.meta || {}) },
          query: { ...(view.query || {}) },
          params: { ...(view.params || {}) }
        }
      },
      addView(view) {
        this.addVisitedView(view)
        this.addCachedView(view)
      },
      addIframeView(view) {
        if (this.iframeViews.some(v => v.path === view.path)) return
        this.iframeViews.push(
          Object.assign({}, view, {
            title: view.meta.title || 'no-name'
          })
        )
      },
      addVisitedView(view) {
        const normalizedView = this.normalizeView(view)
        // 对于支持多标签的详情页（通过 query 参数区分不同详情），使用 fullPath 判断
        // 其他页面仍使用 path 判断（避免搜索条件变化时重复添加标签）
        const multiTabNames = ['ReimbursementAdd', 'ContractAdd', 'ContractDetail']
        const useFullPath = multiTabNames.includes(normalizedView.name)
        const compareKey = useFullPath ? 'fullPath' : 'path'
        
        if (this.visitedViews.some(v => v[compareKey] === normalizedView[compareKey])) return
        this.visitedViews.push(
          Object.assign({}, normalizedView, {
            title: normalizedView.meta.title || 'no-name'
          })
        )
      },
      addCachedView(view) {
        // 取消对部分表单/详情页的统一缓存，每次进入都重新创建实例、重新请求数据
        const noCacheNames = ['ContractAdd', 'ContractDetail']
        if (noCacheNames.includes(view.name)) {
          return
        }
        if (this.cachedViews.includes(view.name)) return
        if (!view.meta.noCache) {
          this.cachedViews.push(view.name)
        }
      },
      delView(view) {
        return new Promise(resolve => {
          this.delVisitedView(view)
          this.delCachedView(view)
          resolve({
            visitedViews: [...this.visitedViews],
            cachedViews: [...this.cachedViews]
          })
        })
      },
      delVisitedView(view) {
        return new Promise(resolve => {
          // 对于支持多标签的详情页，使用 fullPath 判断
          const multiTabNames = ['ReimbursementAdd', 'ContractAdd', 'ContractDetail']
          const useFullPath = multiTabNames.includes(view.name)
          const compareKey = useFullPath ? 'fullPath' : 'path'
          
          for (const [i, v] of this.visitedViews.entries()) {
            if (v[compareKey] === view[compareKey]) {
              this.visitedViews.splice(i, 1)
              break
            }
          }
          this.iframeViews = this.iframeViews.filter(item => item.path !== view.path)
          resolve([...this.visitedViews])
        })
      },
      delIframeView(view) {
        return new Promise(resolve => {
          this.iframeViews = this.iframeViews.filter(item => item.path !== view.path)
          resolve([...this.iframeViews])
        })
      },
      delCachedView(view) {
        return new Promise(resolve => {
          const index = this.cachedViews.indexOf(view.name)
          index > -1 && this.cachedViews.splice(index, 1)
          resolve([...this.cachedViews])
        })
      },
      delOthersViews(view) {
        return new Promise(resolve => {
          this.delOthersVisitedViews(view)
          this.delOthersCachedViews(view)
          resolve({
            visitedViews: [...this.visitedViews],
            cachedViews: [...this.cachedViews]
          })
        })
      },
      delOthersVisitedViews(view) {
        return new Promise(resolve => {
          const multiTabNames = ['ReimbursementAdd', 'ContractAdd', 'ContractDetail']
          const useFullPath = multiTabNames.includes(view.name)
          const compareKey = useFullPath ? 'fullPath' : 'path'
          this.visitedViews = this.visitedViews.filter(v => {
            return v.meta.affix || v[compareKey] === view[compareKey]
          })
          this.iframeViews = this.iframeViews.filter(item => item.path === view.path)
          resolve([...this.visitedViews])
        })
      },
      delOthersCachedViews(view) {
        return new Promise(resolve => {
          const index = this.cachedViews.indexOf(view.name)
          if (index > -1) {
            this.cachedViews = this.cachedViews.slice(index, index + 1)
          } else {
            this.cachedViews = []
          }
          resolve([...this.cachedViews])
        })
      },
      delAllViews(view) {
        return new Promise(resolve => {
          this.delAllVisitedViews(view)
          this.delAllCachedViews(view)
          resolve({
            visitedViews: [...this.visitedViews],
            cachedViews: [...this.cachedViews]
          })
        })
      },
      delAllVisitedViews(view) {
        return new Promise(resolve => {
          const affixTags = this.visitedViews.filter(tag => tag.meta.affix)
          this.visitedViews = affixTags
          this.iframeViews = []
          resolve([...this.visitedViews])
        })
      },
      delAllCachedViews(view) {
        return new Promise(resolve => {
          this.cachedViews = []
          resolve([...this.cachedViews])
        })
      },
      updateVisitedView(view) {
        const normalizedView = this.normalizeView(view)
        const multiTabNames = ['ReimbursementAdd', 'ContractAdd', 'ContractDetail']
        const useFullPath = multiTabNames.includes(normalizedView.name)
        const compareKey = useFullPath ? 'fullPath' : 'path'

        for (let v of this.visitedViews) {
          if (v[compareKey] === normalizedView[compareKey]) {
            v = Object.assign(v, normalizedView)
            break
          }
        }
      },
      delRightTags(view) {
        return new Promise(resolve => {
          const multiTabNames = ['ReimbursementAdd', 'ContractAdd', 'ContractDetail']
          const useFullPath = multiTabNames.includes(view.name)
          const compareKey = useFullPath ? 'fullPath' : 'path'
          const index = this.visitedViews.findIndex(v => v[compareKey] === view[compareKey])
          if (index === -1) {
            return
          }
          this.visitedViews = this.visitedViews.filter((item, idx) => {
            if (idx <= index || (item.meta && item.meta.affix)) {
              return true
            }
            const i = this.cachedViews.indexOf(item.name)
            if (i > -1) {
              this.cachedViews.splice(i, 1)
            }
            if(item.meta.link) {
              const fi = this.iframeViews.findIndex(v => v.path === item.path)
              this.iframeViews.splice(fi, 1)
            }
            return false
          })
          resolve([...this.visitedViews])
        })
      },
      delLeftTags(view) {
        return new Promise(resolve => {
          const multiTabNames = ['ReimbursementAdd', 'ContractAdd', 'ContractDetail']
          const useFullPath = multiTabNames.includes(view.name)
          const compareKey = useFullPath ? 'fullPath' : 'path'
          const index = this.visitedViews.findIndex(v => v[compareKey] === view[compareKey])
          if (index === -1) {
            return
          }
          this.visitedViews = this.visitedViews.filter((item, idx) => {
            if (idx >= index || (item.meta && item.meta.affix)) {
              return true
            }
            const i = this.cachedViews.indexOf(item.name)
            if (i > -1) {
              this.cachedViews.splice(i, 1)
            }
            if(item.meta.link) {
              const fi = this.iframeViews.findIndex(v => v.path === item.path)
              this.iframeViews.splice(fi, 1)
            }
            return false
          })
          resolve([...this.visitedViews])
        })
      }
    }
  })


export default useTagsViewStore
